export const musclesFiltered = (activeTab, musclesState) => {
  if (!musclesState) return;
  if (activeTab === "1") return musclesState.slice(0, 2);
  if (activeTab === "2") return musclesState.slice(0, 4);
  if (activeTab === "3" || activeTab === "4") return musclesState;
};
